import { Header } from './Header'
import { Footer } from './Footer'
import { useLocation } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { CookieConsentBanner } from '../common/CookieConsentBanner'

interface LayoutProps {
  children: React.ReactNode
}

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  
  // Don't add header padding for pages without header
  const hideHeader = location.pathname.startsWith('/admin') || location.pathname === '/solutions/designer'
  
  return (
    <div className="min-h-screen flex flex-col animated-gradient-bg">
      <Header />
      <main className={`flex-1 ${hideHeader ? '' : 'pt-16'}`}>
        {children}
      </main>
      <Footer />
      <Toaster 
        position="bottom-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1f2937',
            color: '#fff',
            borderRadius: '8px',
          },
          success: {
            style: {
              background: '#065f46',
            },
          },
          error: {
            style: {
              background: '#7f1d1d',
            },
          },
        }}
      />
      <CookieConsentBanner />
    </div>
  )
}